import { render } from "./CompanyInviteCard.vue?vue&type=template&id=9c35b4b4&scoped=true"
import script from "./CompanyInviteCard.vue?vue&type=script&lang=js"
export * from "./CompanyInviteCard.vue?vue&type=script&lang=js"

import "./CompanyInviteCard.vue?vue&type=style&index=0&id=9c35b4b4&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c35b4b4"]])

export default __exports__